"use client";

import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { setAxiosTokenData, clearAxiosTokenData } from "@/utils/axiosInstance";

export const useAxiosToken = () => {
  const { token, establishment, baseURL } = useAuth();

  useEffect(() => {
    if (token && baseURL) {
      setAxiosTokenData({
        token,
        establishment: establishment as any,
        baseURL,
      });
    } else {
      clearAxiosTokenData();
    }
  }, [token, establishment, baseURL]);

  return { token, establishment, baseURL };
};
